import React from 'react';
import { Check } from 'lucide-react';
const items = ['Tenés una rutina ocupada y llegás agotada.', 'Querés comer mejor sin vivir cocinando.', 'Querés ahorrar sin resignar variedad.', 'Te gustaría tener más tiempo libre real.', 'Estás cansada de improvisar.'];
export function IsThisForYou() {
  return <section className="py-5 md:py-7 px-4 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-136">
          ¿Es para vos?
        </h2>

        <div className="bg-[#F7F5F0] p-4 md:p-5 border border-black/10 rounded-2xl shadow-sm" data-id="element-137">
          <ul className="space-y-2 md:space-y-2.5" data-id="element-138">
            {items.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-139">
                <div className="bg-primary/10 p-1 shrink-0 rounded-full" data-id="element-140">
                  <Check className="text-primary" size={16} data-id="element-141" />
                </div>
                <span className="text-xs md:text-sm text-text-primary/90 font-bold" data-id="element-142">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}